import React from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';

import NotFound from '../../NotFoundPage';
import PromoterBusiness from '../../../components/Models/PromoterComponent';
import PromoterCompanyForm from '../../../components/Models/PromoterComponent/Form';

/**
 * @component
 */
function PromoterCompanies() {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={path} component={PromoterBusiness} />
      <Route path={`${path}/:id`} component={PromoterCompanyForm} />
      <Route path="" component={NotFound} />
    </Switch>
  );
}

export default PromoterCompanies;
